import { Injectable } from '@angular/core';
import {StatusBar, Style} from "@capacitor/status-bar";
import {NavigationBar} from "@hugotomazi/capacitor-navigation-bar";

@Injectable({
  providedIn: 'root'
})
export class StatusbarAndNavbarService {

  constructor() { }

  async applyColor(color: string = "#FFFFFF", darkMode: boolean = false) {

    if (!color || !color.match(/^#[0-9A-Fa-f]{6}$/)) {
      console.warn("Invalid color format. Color must be a valid hex color (e.g., '#FF0000')");
      return;
    }

    try {
      await StatusBar.setBackgroundColor({color: color});
      await StatusBar.setStyle({style: darkMode? Style.Dark : Style.Light});
      await StatusBar.setOverlaysWebView({overlay: true});
    } catch (e) {
      console.info("StatusBar not available on this platform");
    }

    try {
      console.debug("Changing NavigationBar color to: " + color);
      await NavigationBar.setColor({color: color, darkButtons: !darkMode});
      await NavigationBar.setTransparency({
        isTransparent: true
      });
    } catch (e) {
      console.info("NavigationBar not available on this platform");
    }
  }
}
